import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:3001';

// Skapa axios-instans med bas-URL och konfiguration
const api = axios.create({
  baseURL: `${API_URL}/api`,
  timeout: 30000, // 30 sekunder timeout
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor för att lägga till auth token
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor för att hantera fel
api.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    // Hantera 401 Unauthorized
    if (error.response?.status === 401) {
      localStorage.removeItem('token');
      // Omdirigera till login om nödvändigt
      window.location.href = '/login';
    }
    
    return Promise.reject(error);
  }
);

export default api; 